import { defineStore } from "pinia";

export const useNavBarStore = defineStore("navbar", {
  state: (): { expanded: boolean } => ({
    expanded: false,
  }),
  actions: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
});
